// import { mqttWorkerClient } from './mqtt-worker-client'; // BROKER (direct) path — temporarily disabled, see note below
import { mqttGatewayClient } from './mqtt-gateway-client';

/**
 * Shared MQTT transport selector.
 *
 * >>> TEMPORARILY LOCKED TO 'gateway' <<<
 * The direct-broker path (mqttWorkerClient → Paho MQTT-over-WebSocket straight to
 * the broker) is disabled for now. All MQTT traffic goes through the app WebSocket
 * gateway (mqttGatewayClient → conf.websocket.url), which relays to the broker
 * server-side. Because nothing imports `mqtt-worker-client` anymore, the Paho
 * client / SharedWorker is no longer instantiated.
 *
 * To RE-ENABLE the selectable broker/gateway behaviour later:
 *   1. Uncomment the `mqttWorkerClient` import above.
 *   2. Restore the original `getMqttTransportKind()` body (commented below).
 *   3. Restore the conditional `mqttTransport` binding (commented below).
 */
export type MqttTransportKind = 'broker' | 'gateway';

export function getMqttTransportKind(): MqttTransportKind {
    // --- Locked to gateway while the broker path is disabled ---
    return 'gateway';

    // --- Original selectable logic (re-enable together with the import above) ---
    // try {
    //     if (typeof localStorage !== 'undefined') {
    //         const flag = localStorage.getItem('USE_GATEWAY_TRANSPORT');
    //         if (flag === '1') return 'gateway';
    //         if (flag === '0') return 'broker';
    //     }
    // } catch { /* localStorage may be unavailable */ }
    // const configured = (conf as any)?.mqtt?.transport;
    // if (configured === 'broker' || configured === 'gateway') return configured;
    // if ((conf as any)?.mqtt?.useGateway) return 'gateway';
    // return 'broker';
}

export function useGatewayTransport(): boolean {
    return getMqttTransportKind() === 'gateway';
}

/** The transport kind resolved once at module load. */
export const MQTT_TRANSPORT_KIND: MqttTransportKind = getMqttTransportKind();

/** Human label for logs/UI. */
export const MQTT_TRANSPORT_LABEL =
    MQTT_TRANSPORT_KIND === 'gateway' ? 'WebSocket gateway' : 'direct broker';

/**
 * The selected MQTT transport singleton, shared app-wide.
 * Locked to the gateway client for now.
 */
export const mqttTransport = mqttGatewayClient;
// Original selectable binding (re-enable with the `mqttWorkerClient` import above):
// export const mqttTransport: typeof mqttWorkerClient =
//     (MQTT_TRANSPORT_KIND === 'gateway' ? mqttGatewayClient : mqttWorkerClient) as any;

console.log('MQTT transport:', MQTT_TRANSPORT_LABEL);
